import type { Discount } from '@carvana/merch-contracts';
import DiscountType from '@carvana/merch-contracts/DiscountType';
import { useMemo } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import { useVehiclePaymentTerms } from '~/context/vdp/UserVehicleContext';

export default function useGetGeicoDiscount(): Discount | null {
  const { enableGeicoDiscount = false } = useConfiguration();
  const { discounts = [] } = useVehiclePaymentTerms();

  return useMemo<Discount | null>(
    () =>
      enableGeicoDiscount
        ? discounts.find(
            discount => discount.type === DiscountType.GeicoTotalLoss
          ) ?? null
        : null,
    [discounts, enableGeicoDiscount]
  );
}
